import CryptoES from "crypto-es";

import { VITE_ENCRYPT_KEY } from "@/constants";

import { type Message, MessageType, MessageStatus } from "./types";

const generateEncryptionKey = (): string => {
  try {
    if (!VITE_ENCRYPT_KEY) {
      throw new Error("Failure to get token");
    }

    return VITE_ENCRYPT_KEY;
  } catch (error) {
    console.error("Generate encryption key failed:", error);
    throw new Error("Generate encryption key failed");
  }
};

export const useEncryption = () => {
  const encryptionKey = generateEncryptionKey();
  const encrypt = (message: Message): string => {
    try {
      const messageToEncrypt = JSON.stringify(message);

      return CryptoES.AES.encrypt(messageToEncrypt, encryptionKey).toString();
    } catch (error) {
      console.error("Encryption failed:", error);
      throw new Error("Message encryption failed");
    }
  };

  const decrypt = (hash: string): Message => {
    try {
      const decrypted = CryptoES.AES.decrypt(hash, encryptionKey).toString(CryptoES.enc.Utf8);
      const message: Message = JSON.parse(decrypted);

      if (message.type in MessageType && message.state in MessageStatus) {
        return message;
      } else {
        throw new Error("Received a postMessage that doesn't correspond to a Portal message");
      }
    } catch (error) {
      console.error("Decryption failed:", error);
      throw new Error("Message decryption failed");
    }
  };

  return { encrypt, decrypt };
};
